// removed by extract-text-webpack-plugin
module.exports = {"base":"_2gguP","head":"_6CklM","topPadding":"_32_tX","heading":"_1znrU","hr":"_1p4fV","cta":"pXMM6","list":"_26mTP","empty":"g-kOf","createButton":"_1pa-G","divider":"_3ONiS","pencil":"_1m56N","container":"_2v7iu","label":"_2zP1s","value":"cO2Cs","optionadmins":"_3zf28","adminfunction":"_2XvJH","partnerplanImg":"_1jDJp","partnerplanDoc":"_1qnXg","partnerplanFlex":"_2coVF","partnerplanFlexLeft":"_1BPjO","partnerplanFlexRight":"_2jfzk","partnerplanDocumentEdit":"_2CHHq"};


//////////////////
// WEBPACK FOOTER
// ./src/components/Sidebar/Sidebar.scss
// module id = 1856
// module chunks = 0